// extracted by mini-css-extract-plugin
module.exports = {"greenButton":"GreenButton_greenButton__4rZT2","gradient":"GreenButton_gradient__AezCu","buttonText":"GreenButton_buttonText__dAaaa","link":"GreenButton_link__2ewKc"};